import { CampaignWithSuppressionData } from "~frontend/routes/types";
import { jobInProgress } from "~frontend/util/jobs";

export const suppressionJobKeys = [
  "calculateCampaignOverlapsJob",
  "createSuppressionsFromCampaignOverlapsJob",
  "createSuppressionsFromListJob",
  "createSuppressionsFromShortcodeSubscribersJob",
  "createSuppressionsFromAudiencesJob",
  "deleteSuppressionsJob",
] as const;

export function isSuppressionJobRunning(
  campaign: CampaignWithSuppressionData
): boolean {
  return suppressionJobKeys.some(
    jobKey => campaign[jobKey] && jobInProgress(campaign[jobKey]!)
  );
}
